import { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { getAuth0Token } from '@/services/tokenManager'
import { DEFAULT_ROUTE } from '@/common/constants'
import { getFirstVisibleModulePath } from '../routes'

export type MiddlewareOptions = {
  to: RouteLocationNormalized
  from: RouteLocationNormalized
}

export type Middleware = (
  options: MiddlewareOptions
) =>
  | RouteLocationRaw
  | boolean
  | string
  | Promise<RouteLocationRaw | boolean | string>

export const isAuthenticated: Middleware = async ({ to }) => {
  const isAuthenticated = !!(await getAuth0Token())
  if (isAuthenticated) {
    return true
  } else {
    return {
      path: '/login',
      query: { redirectTo: encodeURIComponent(to.fullPath) },
    }
  }
}

export const isRootAuthenticated: Middleware = async () => {
  const isAuthenticated = !!(await getAuth0Token())

  if (isAuthenticated) {
    return { path: getFirstVisibleModulePath() }
  } else {
    return { name: 'Login' }
  }
}

export const isNotAuthenticated: Middleware = async () => {
  const isAuthenticated = !!(await getAuth0Token())
  if (isAuthenticated) {
    return { path: DEFAULT_ROUTE }
  } else {
    return true
  }
}

export const projectMiddlewares = {
  isAuthenticated,
  isRootAuthenticated,
  isNotAuthenticated,
}
